import { LOG_UID_ELEMENT_ID } from "app/components/AnalyticLogger";
import { GLOBALS } from "config";
import Cookies from "js-cookie";
import { ReadonlyURLSearchParams } from "next/navigation";

export const LOG_EVENT_DETAILS = {
  plusTop: "plus_top",
  seriesTop: "series_top",
  episodeTop: "episode_top",
  clickThumb: "clk-thumb",
  category: "category",
  categoryAuthor: "category-author",
  search: "search",
  ranking: "ranking",
  series: "series",
  seriesSummary: "seriesSummary",
  genre: "genre",
} as const;

export const LOG_CATEGORIES = {
  carousel: "carousel",
  gacha: "gacha",
  recommend: "recommend",
  specialFeature: "specialfeature",
  updatedToday: "updated_today",
  storeItem: "store_item",
  category: "category",
  externalLink: "external_link",
  storeLink: "store_link",
  list: "list",
  categoryContinue: "categorycontinue",
  rankingManga: "rankingmanga",
  rankingGravure: "rankinggravure",
  rankingColumn: "rankingcolumn",
  popularSeries: "popular_series",
  series: "series",
  article: "article",
  null: "categorynull",
} as const;

export type AnalyticLogProps = {
  logCategory?: string;
  logEventDetail?: string;
  logRequestId?: string;
  logSessionId?: string;
  logUserId?: string;
  logSeriesId?: number;
  logArticleId?: number;
  logImageId?: number;
  logPosition?: string;
  logStoreType?: string;
  logStoreItemVolumeId?: string;
  logFeatureItemId?: number;
  logCarouselBannerId?: string;
};

type logDataAttrs = {
  "data-log-category"?: string;
  "data-log-event-detail"?: string;
  "data-log-series-id"?: string;
  "data-log-article-id"?: string;
  "data-log-image-id"?: string;
  "data-log-position"?: string;
  "data-log-store-type"?: string;
  "data-log-store-item-volume-id"?: string;
  "data-log-feature-item-id"?: string;
  "data-log-carousel-banner-id"?: string;
};
export type impLogDataAttrs = {
  "data-log-imp": boolean;
} & logDataAttrs;

export type clickLogDataAttrs = {
  "data-log-click": boolean;
} & logDataAttrs;

function _str(numOrUndef: number | undefined): string {
  if (numOrUndef === undefined) {
    return "";
  } else {
    return String(numOrUndef);
  }
}

function parseLogAttrs(params: AnalyticLogProps): logDataAttrs {
  if (!params) {
    return {};
  }
  return {
    "data-log-category": params.logCategory,
    "data-log-event-detail": params.logEventDetail,
    "data-log-series-id": _str(params.logSeriesId),
    "data-log-article-id": _str(params.logArticleId),
    "data-log-image-id": _str(params.logImageId),
    "data-log-position": params.logPosition,
    "data-log-store-type": params.logStoreType,
    "data-log-store-item-volume-id": params.logStoreItemVolumeId,
    "data-log-feature-item-id": _str(params.logFeatureItemId),
    "data-log-carousel-banner-id": params.logCarouselBannerId,
  };
}

export function makeImpLogDataAttrs(params: AnalyticLogProps): impLogDataAttrs {
  const res = Object.assign({ "data-log-imp": true }, parseLogAttrs(params));
  return res;
}
export function makeClickLogDataAttrs(params: AnalyticLogProps): clickLogDataAttrs {
  const res = Object.assign({ "data-log-click": true }, parseLogAttrs(params));
  return res;
}

export function sendClickLog(params: { [key: string]: string | undefined }) {
  params.event_type = "clk";
  sendLogEvent(params);
}
export function sendImpLog(attrs: impLogDataAttrs) {
  const res: { [key: string]: string | undefined } = {
    event_type: "imp",
    event_detail: attrs["data-log-event-detail"],
    category: attrs["data-log-category"],
    position: attrs["data-log-position"],
    series_id: attrs["data-log-series-id"],
    article_id: attrs["data-log-article-id"],
    carousel_banner_id: attrs["data-log-carousel-banner-id"],
    feature_item_id: attrs["data-log-feature-item-id"],
    store_type: attrs["data-log-store-type"],
    store_item_volume_id: attrs["data-log-store-item-volume-id"],
  };
  sendLogEvent(res);
}
export function sendLoadPageLog() {
  sendLogEvent({ event_type: "loadpage" });
}

export function sendActiveUserLog(userId: string | undefined) {
  if (userId) {
    sendLogEvent({
      event_type: "active",
      event_datail: GLOBALS.LOG_SITE_NAME,
      category: GLOBALS.LOG_DOMAIN,
      user_id: userId,
    });
  }
}

const SESSION_ID_KEY = "cv_session_id";
let requestId: string;
export function updateRequestId(): void {
  requestId = "cv" + new Date().getTime() + "-" + Math.floor(Math.random() * 10000);
}
function getRequestId(): string {
  if (!requestId) {
    updateRequestId();
  }
  return requestId;
}
function getSessionId(): string {
  if (typeof window !== "undefined") {
    let sid = window.sessionStorage.getItem(SESSION_ID_KEY);
    if (!sid) {
      sid = requestId;
      window.sessionStorage.setItem(SESSION_ID_KEY, sid);
    }
    return sid;
  } else {
    return "";
  }
}

function sendLogEvent(params: { [key: string]: string | undefined }) {
  //let uidHash = await getHashedUserId();
  params = Object.assign(
    {
      timestamp: new Date().getTime(),
      user_id: document?.getElementById(LOG_UID_ELEMENT_ID)?.textContent,
      tid: GLOBALS.LOG_TRACKING_ID,
    },
    {
      url: location.href,
      request_id: getRequestId(),
      session_id: getSessionId(),
    },
    params,
  );
  const q = [];
  let qStr: string, key: string, val: string | undefined;
  let qLen = 0;
  for (key in params) {
    val = params[key];
    if (val) {
      qStr = key + "=" + encodeURIComponent(val);
      qLen += qStr.length;
      q.push(qStr);
    }
  }
  //必須じゃないパラメータ
  const LOG_ADDITIONAL_PARAMS: { [key: string]: string } = {
    language: navigator.language,
    user_language: navigator.language,
    user_agent: navigator.userAgent,
    referrer: document.referrer,
    screen_width: "",
    screen_height: "",
  };
  for (key in LOG_ADDITIONAL_PARAMS) {
    val = LOG_ADDITIONAL_PARAMS[key];
    //幅と高さは送信直前に設定する
    if (key === "screen_width") {
      val = String(window.innerWidth);
    }
    if (key === "screen_height") {
      val = String(window.innerHeight);
    }
    if (val) {
      qStr = key + "=" + encodeURIComponent(val);
      qLen = qLen + qStr.length;
      if (qLen < 2048) {
        q.push(qStr);
      }
    }
  }
  new Image().src = "https://" + GLOBALS.LOG_ENDPOINT_DOMAIN + "/collect?" + q.join("&");
}

// 広告キャンペーン経由での登録/コインチャージ解析用

export const CAMPAIGN_COOKIE_LIFETIME_MS = 1000 * 60 * 60; // 1時間
export const CAMPAIGN_REGISTER_COOKIE_NAME = "ads_campaign_target";

/**
 * キャンペーン経由で登録されたかどうかの確認用Cookieをセットする
 * @param query URLSearchParams
 */
export function setCampaignRegisterCookie(query: ReadonlyURLSearchParams) {
  const source = query.get("utm_source");
  if (source) {
    const medium = query.get("utm_medium");
    const campaign = query.get("utm_campaign");
    Cookies.set(CAMPAIGN_REGISTER_COOKIE_NAME, `${source},${medium},${campaign}`, {
      expires: new Date(Date.now() + CAMPAIGN_COOKIE_LIFETIME_MS),
    });
  }
}

/**
 * キャンペーン経由で登録されたかどうかの確認用Cookieを削除する
 */
export function deleteCampaignRegisterCookie() {
  Cookies.remove(CAMPAIGN_REGISTER_COOKIE_NAME);
}

/**
 * キャンペーン経由でコインチャージされたかどうかの確認用Cookieをセットする
 * @param type "series" | "article"
 * @param seriesOrCampaignId number, seriesId or campaignId
 * @param query URLSearchParams
 */
export function setCampaignPaymentCookie(
  type: "series" | "article",
  seriesOrCampaignId: number | undefined,
  query: ReadonlyURLSearchParams,
) {
  if (seriesOrCampaignId && query.get("utm_source")) {
    Cookies.set(`charge_via_ads_${type}_${seriesOrCampaignId}`, "true", {
      expires: new Date(Date.now() + CAMPAIGN_COOKIE_LIFETIME_MS),
    });
  }
}

/**
 * キャンペーン経由でコインチャージされたかどうかの確認用Cookieを削除する
 * @param type "series" | "article"
 * @param seriesOrCampaignId number, seriesId or campaignId
 */
export function deleteCampaignPaymentCookie(
  type: "series" | "article",
  seriesOrCampaignId: number | undefined,
) {
  if (seriesOrCampaignId) {
    Cookies.remove(`charge_via_ads_${type}_${seriesOrCampaignId}`);
  }
}
